import { getBusinessLang } from '@/utils/requestLang';

interface ILocaleTarget {
  locale: string;
}

interface IMutationSource {
  subscribe(handler: (mutation: { type: string }) => void): unknown;
}

const SET_BUSINESS_INFO = 'business/setBusinessInfo';

/**
 * The copy follows the business's country, as on the host and as the `x-lang`
 * header already does: the merchant has no language switcher. The browser
 * language is deliberately not used, so a US merchant on a Portuguese browser
 * keeps the English copy.
 */
export const followBusinessLocale = (
  store: IMutationSource,
  i18n: ILocaleTarget
): void => {
  const apply = () => {
    const lang = getBusinessLang();
    if (lang && i18n.locale !== lang) i18n.locale = lang;
  };

  apply();
  store.subscribe(({ type }) => {
    if (type === SET_BUSINESS_INFO) apply();
  });
};
